export default "__VITE_ASSET__BFhHoK$c__"